import { XMarkIcon } from '@heroicons/react/20/solid';
import { SupplierFacetState, hasActiveFacets } from './supplierFacets';
import { sourceTypeLabelOf } from './supplierTypes';

export interface SupplierActiveFiltersProps {
  facets: SupplierFacetState;
  onRemoveSourceType: (value: string) => void;
  onRemoveBrand: (value: string) => void;
  onRemoveCoverage: (value: string) => void;
  onClearAll: () => void;
}

function FilterChip({
  label,
  onRemove,
}: {
  label: string;
  onRemove: () => void;
}) {
  return (
    <span className='inline-flex items-center gap-1.5 rounded-lg bg-blue-50 px-2.5 py-1 text-sm font-medium text-primary'>
      {label}
      <button
        type='button'
        aria-label={`Remove ${label} filter`}
        onClick={onRemove}
        className='rounded hover:text-blue-800'
      >
        <XMarkIcon className='h-4 w-4' />
      </button>
    </span>
  );
}

export function SupplierActiveFilters({
  facets,
  onRemoveSourceType,
  onRemoveBrand,
  onRemoveCoverage,
  onClearAll,
}: SupplierActiveFiltersProps) {
  if (!hasActiveFacets(facets)) return null;

  return (
    <div className='flex flex-wrap items-center gap-2 font-inter'>
      {[...facets.sourceTypes].map((value) => (
        <FilterChip
          key={`type-${value}`}
          label={`Type: ${sourceTypeLabelOf(value)}`}
          onRemove={() => onRemoveSourceType(value)}
        />
      ))}
      {[...facets.brands].map((value) => (
        <FilterChip
          key={`brand-${value}`}
          label={`Brand: ${value}`}
          onRemove={() => onRemoveBrand(value)}
        />
      ))}
      {[...facets.coverage].map((value) => (
        <FilterChip
          key={`coverage-${value}`}
          label={`Branch: ${value}`}
          onRemove={() => onRemoveCoverage(value)}
        />
      ))}
      <button
        type='button'
        onClick={onClearAll}
        className='ml-1 text-sm font-medium text-gray-500 hover:text-gray-900'
      >
        Clear all
      </button>
    </div>
  );
}
